import React from "react";
import CTAButton from "../CTAButton/CTAButton";
import "./GrowAudience.css";
import soon from "../../assets/connect.png";
import aiFallback from "../../assets/Grow your audience Mailsnappy.jpeg";
import { Link } from 'react-router-dom';
import emailsignup from "../../assets/new/Email Signup Forms That Convert More Visitors mailsnappy.png";


const GrowAudience = () => {
  return (
    <div className="grow-page">
      {/* HERO SECTION */}
      <section className="grow-hero">
        <div className="hero-left">
          <Link to="/features" className="back-link">← Back to features</Link>
          <h1>Grow Your Email List with Powerful Audience Building Tools</h1>
          <p>
            Growing your audience starts with the right tools. MailSnappy helps you attract new subscribers, capture qualified leads, and build a high quality email list using customizable signup forms, responsive landing pages, and seamless integrations. Whether you are launching a newsletter, promoting a product, or collecting leads, our email marketing platform makes audience growth simple, scalable, and effective.
          </p>
          <div className="hero-form"><CTAButton>Get started</CTAButton></div>
        </div>
        <div className="hero-right">
          <img src={aiFallback} alt="Mailsnappy audience growth tools preview" width="640" height="420" />
        </div>
      </section>

      {/* SIGN-UP FORMS */}
      <section className="signup-section">
        <div className="signup-left">
          <img src={emailsignup} alt="Email signup form builder preview" width="640" height="420" loading="lazy" />
        </div>
        <div className="signup-right">
          <h2>Email Signup Forms That Convert More Visitors</h2>
          <p>
            Create professional email signup forms that match your brand and encourage more visitors to subscribe. Customize layouts, colors, fields, and calls to action, then easily embed forms on your website or share them with a direct link. Every form is optimized to help you generate more leads and grow your email list faster.
          </p>
        </div>
      </section>

      {/* TESTIMONIAL */}
      <section className="testimonial">
        <div className="testimonial-container">
          <div className="testimonial-text">
            <p>
              “Mailsnappy’s form builder helped us capture more leads effortlessly. 
              We grew our mailing list 3× faster using simple, mobile-friendly signup forms.”
            </p>
            <p className="author">– Kai Brown, Denso Discovery</p>
          </div>
          <img src={aiFallback} alt="Audience growth customer testimonial avatar" className="testimonial-img" width="96" height="96" loading="lazy" />
        </div>
      </section>

      {/* LANDING PAGES */}
      <section className="landing-section">
        <div className="landing-left">
          <h2>Landing Pages for Lead Generation and Email List Growth</h2>
          <p>
            Launch responsive landing pages in minutes without writing code or hiring a designer. Promote products, collect leads, grow your newsletter audience, or run marketing campaigns with professionally designed landing pages that help turn visitors into loyal subscribers.
          </p>
        </div>
        <div className="landing-right">
          <img src={aiFallback} alt="Landing page lead generation preview" width="640" height="420" loading="lazy" />
        </div>
      </section>

      {/* INTEGRATIONS COMING SOON */}
      <section className="coming-soon-section">
        <div className="coming-container">
          <h2>Email Marketing Integrations to Connect Your Favorite Tools</h2>
          <p>
            MailSnappy is expanding with powerful email marketing integrations to help you automate workflows and connect your business tools. Soon you will be able to integrate with WordPress, Shopify, Zapier, and other popular platforms, making it easier to manage subscribers, automate email campaigns, and streamline your marketing from one place.
          </p>
          <img src={soon} alt="Email marketing integration preview" width="640" height="420" loading="lazy" />
        </div>
      </section>

      {/* AUDIENCE WITH MAILSNAPPY */}
      <section className="coming-container">
        <div className="landingalgin">
          <h2>Build a Bigger Audience with MailSnappy</h2>
          <p>
Whether you are starting from your first subscriber or managing a growing customer base, MailSnappy provides the tools you need to attract, engage, and convert more people. From high converting signup forms and responsive landing pages to upcoming integrations and automation, our <Link className="linkcolor" to="/email-marketing-platform">email marketing platform</Link> helps you grow your audience with confidence and achieve long term business success
  </p>
  </div>
        {/* </div>
        {/* <div className="landing-right">
        //   <img src={landingpage} alt="Landing Page Example" />
        // </div> */}
      </section>

      {/* CTA */}
      <section className="cta-section">
        <h2>Start for free today</h2>
        <p>Sign up and send your first campaign in minutes. No credit card required.</p>
        <CTAButton className="primary-btn">Get started</CTAButton>
      </section>
    </div>
  );
};

export default GrowAudience;
